import React from "react";

import './destination.css'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel'; 
import Typography from '@mui/material/Typography';
import SimpleImageSlider from "react-simple-image-slider";
import Swipernew from "./Swipernew";
import slide_image_1 from '../pages/image1/jin5.jpg';
import slide_image_2 from '../pages/image1/jin6.jpg';
import slide_image_3 from '../pages/image1/jin7.jpg';
import slide_image_4 from '../pages/image1/jin8.jpg';

export default function Destination7() {

  const imageArray = [
    slide_image_1,
    slide_image_2,
    slide_image_3,
    slide_image_4,
   
  ];
  return (
    <>
    <div>
    <div>
            <Swipernew images={imageArray} />
        </div>
<div className="m-2 pt-5">
  <div className="container-fluid">
  <div className="ms-auto me-auto  bg2">

<h1 className="text-center name11  ">
2 Days Weekend Getaway sightseeing tour to Jinja City
</h1>
</div>


    <h2>Description:</h2>
    <h3 className="ms-5 pt-3">
      &emsp;&emsp;Japland tours and Safaris offers you an adventurous 2 days weekend getaway sightseeing tour to Jinja with a visit to Busowooko Falls and a boat cruise to the Sources of the Nile River. River Nile is the longest river in the whole world.
    </h3>
  </div>
</div>


        <div className="container-fluid">
        <Box sx={{ padding: 2 }}>
      <Stepper orientation="vertical" activeStep={5}>
        {steps.map((step, index) => (
          <Step key={step.label1} color="black">
            {/* Pass label1 to StepLabel */}

            <StepLabel><h3> {step.label1}</h3></StepLabel>
            <div className=" bordernew  ">
            {/* Add the secondary label (optional, shown below the main one) */}
            <Typography variant="subtitle1" color="textblack" sx={{ ml: 2 }}>
              <h4><b>{step.label}</b></h4>
            </Typography>
            {/* Directly display the description */}
            <Typography sx={{ mt: 1, mb: 2, ml: 2 }}><h4>&emsp;{step.description}</h4></Typography></div>
          </Step>
        ))}
      </Stepper>
    </Box>
          
          
      
      </div>
      <div class="btn-box text-white text-center">
                        <a href="https://wa.me/+971551579904" class="theme-btn btn-style-one rounded-3 m-4 ">Book Now</a>
                    </div>
                    </div>
    </>
  );
}
const steps = [
  {
    label1: 'Day - 1',
    label: ' Kampala – Jinja',
 
    description:  (<><p>Our guide will meet you at your hotel to start your journey to Jinja . You will enjoy the beautiful sceneries on your way, interact with the local people at refreshment point. This journey is approximately 2 hours from Kampala City </p> <p>Indulge in a spontaneous local Dinner with a cool breeze and overnight at Source of the Nile Hotel.</p></>)
  },
  { 
    label1: 'Day - 2',
    label: ' Source of the Nile Cruise & Visit the Uganda Railway Museum(Highlights-Chimpanzee)',

    description:
    (<><p>You will be served to a freshly made breakfast and then depart for the cruise at the source of the Nile and then to the nearby fishing villages, Mahatma Ghandi Monument and thereafter you visit the Uganda Railway Museum. </p><p>Have lunch and depart for Kampala.</p></>)
       
  },
 
];
